import React from 'react'
import { readStoredJson, writeStoredJson } from '../../lib/safeStorage'

// Menu favorit, per peran, diingat di peramban ini. Dibaca oleh Sidebar (grup
// "Favorit") dan GlobalSearch (palet Ctrl+K), jadi disimpan di store modul +
// useSyncExternalStore supaya keduanya selalu sejalan tanpa provider tambahan.
//
// Yang disimpan hanya id menu. Id yang tak lagi ada di menu peran itu (menu
// dihapus, atau peran berganti) disaring oleh pemanggil saat dirender.
const keyFor = (role) => `gladhy_nav_favs:${role}`
const EMPTY = []

const cache = new Map() // role -> array id; referensinya stabil sampai berubah
const listeners = new Set()

function read(role) {
  if (!cache.has(role)) {
    const saved = readStoredJson(keyFor(role), EMPTY)
    const ids = Array.isArray(saved) ? saved.filter((v) => typeof v === 'string') : EMPTY
    cache.set(role, ids.length ? ids : EMPTY)
  }
  return cache.get(role)
}

function write(role, next) {
  cache.set(role, next.length ? next : EMPTY)
  writeStoredJson(keyFor(role), next)
  listeners.forEach((fn) => fn())
}

const subscribe = (fn) => {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

export function useFavorites(role) {
  const favs = React.useSyncExternalStore(subscribe, () => read(role))
  const toggle = React.useCallback((id) => {
    const cur = read(role)
    write(role, cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id])
  }, [role])
  return { favs, toggle }
}
